import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-reservations',
  templateUrl: './user-reservations.component.html',
  styleUrls: ['./user-reservations.component.scss']
})
export class UserReservationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
